jQuery(function($){ 
  function dropDown() {
    elementClick = '.header_toggle';
    elementSlide = '.header_slide_element';
    activeClass  = 'active';
    $(elementClick).on('click', function(e) {
      e.stopPropagation();
      var subUl = $(this).next(elementSlide);
      $(this).toggleClass(activeClass);

      $(elementClick).not(this).removeClass(activeClass);
      e.preventDefault();
    });
    $(document).on('click', elementSlide, function(e) {
      e.stopPropagation();
    });
    $(document).on('click', function(e) {
      e.stopPropagation();
      if (e.which != 3) {
        var elementHide = $(elementClick).next(elementSlide);
        // $(elementHide).hide();
        $(elementClick).removeClass('active');
      }
    });
  }
  dropDown()
});

$('.qtyplus').click(function(e){
  e.preventDefault();
  var currentVal = parseInt($('input[name="quantity"]').val());
  if (!isNaN(currentVal)) {
    $('input[name="quantity"]').val(currentVal + 1);
  } else {
    $('input[name="quantity"]').val(1);
  }
});

$(".qtyminus").click(function(e) {
  e.preventDefault();
  var currentVal = parseInt($('input[name="quantity"]').val());
  if (!isNaN(currentVal) && currentVal > 0) {
    $('input[name="quantity"]').val(currentVal - 1);
  } else {
    $('input[name="quantity"]').val(1);
  }
});
$('.quick-view .close-window').click(function() {  			
  $('.quick-view').switchClass("open-in","open-out");
});
$(document).ready(function(){
  $(".home-fcoll-section-slider").owlCarousel({
    items : 1,
    singleItem:true,
    navigation : false
  });
  $(document).on('click','.hero-category-thumbnail a',function(){
    var target = $(this).data('target'),
        stepname = $(this).data('stepname');
    if(target!==0){
      $(this).closest('.slides-text').hide();
      $('.'+target).show();
      $('.home-top-collections-slider .header-text').text(stepname);
    }
  });
});
if($(window).width()<768){
  $(document).on('click','.sidebar-tag .widget',function(e){
    e.preventDefault();
    var parent= $(this).closest('.sidebar-tag').toggleClass('active-tag-gd');
    $(this).next('.widget-content').slideToggle("slow");
  });
}